import { WindowProxy } from '@sm360/widget-commons-core-services';

import { validateSelectedOptions } from 'commons-vehicle/ModelYear/actions/modelYearActions.js';
import { setQuoteModified } from 'commons-vehicle/Quote/actions/quoteActions.js';

import * as purchaseMethodsTypes from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActionTypes.js';

export function loadPurchaseMethodsSuccess(purchaseMethods) {
    return { type: purchaseMethodsTypes.LOAD_PURCHASE_METHODS_SUCCESS, purchaseMethods };
}

export function selectPurchaseMethod(purchaseMethod) {
    return (dispatch, getState) => {
        dispatch({ type: purchaseMethodsTypes.SELECT_PURCHASE_METHOD, purchaseMethod });
        dispatch(validateSelectedOptions()).then(() => {
            const state = getState();
            const selectedOptionsPackage = state.modelYear.getSelectedOptionsPackage();
            dispatch(loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods));
            dispatch(setQuoteModified());
        });
    };
}

export function selectTerm(term) {
    return { type: purchaseMethodsTypes.SELECT_TERM, term };
}

export function selectPaymentFrequency(paymentFrequency) {
    return { type: purchaseMethodsTypes.SELECT_PAYMENT_FREQUENCY, paymentFrequency };
}

export function setCashDown(cashDown) {
    return { type: purchaseMethodsTypes.SET_CASH_DOWN, cashDown };
}

export function setTradeIn(tradeIn) {
    const windowProxy = WindowProxy.get();
    if (windowProxy && windowProxy.localStorage) {
        windowProxy.localStorage.setItem('tradeIn', parseInt(tradeIn, 10));
    }
    return { type: purchaseMethodsTypes.SET_TRADE_IN, tradeIn };
}

export function setLien(lien) {
    const windowProxy = WindowProxy.get();
    if (windowProxy && windowProxy.localStorage) {
        windowProxy.localStorage.setItem('lien', parseInt(lien, 10));
    }
    return { type: purchaseMethodsTypes.SET_LIEN, lien };
}

export function setExteriorColourAmounts(exteriorColourAmounts) {
    return { type: purchaseMethodsTypes.SET_EXTERIOR_COLOUR_AMOUNTS, exteriorColourAmounts };
}

export function setInteriorColourAmounts(interiorColourAmounts) {
    return { type: purchaseMethodsTypes.SET_INTERIOR_COLOUR_AMOUNTS, interiorColourAmounts };
}

export function setOptionsAmounts(optionsAmounts) {
    return { type: purchaseMethodsTypes.SET_OPTIONS_AMOUNTS, optionsAmounts };
}

export function setDeliveryFee(addFee) {
    return { type: purchaseMethodsTypes.SET_DELIVERY_FEE, addFee };
}

export function setDeposit(deposit) {
    return { type: purchaseMethodsTypes.SET_DEPOSIT, deposit };
}

export function setTaxesIncluded(taxesIncluded) {
    return { type: purchaseMethodsTypes.SET_TAXES_INCLUDED, taxesIncluded };
}

export function setKMPlan(kmPlan) {
    return { type: purchaseMethodsTypes.SELECT_KM_PLAN, kmPlan };
}

export function selectOptionsResolution(resolutionId) {
    return { type: purchaseMethodsTypes.SELECT_OPTIONS_RESOLUTION, resolutionId };
}

export function resetIncentivesRebates() {
    return { type: purchaseMethodsTypes.RESET_SELECTED_INCENTIVE_REBATES };
}

export default {
    loadPurchaseMethodsSuccess,
    selectPurchaseMethod,
    selectTerm,
    selectPaymentFrequency,
    setCashDown,
    setTradeIn,
    setLien,
    setExteriorColourAmounts,
    setInteriorColourAmounts,
    setOptionsAmounts,
    setDeliveryFee,
    setDeposit,
    setTaxesIncluded,
    setKMPlan,
    selectOptionsResolution,
    resetIncentivesRebates,
};
